import { render, staticRenderFns } from "./PaymentsSuccessPage.vue?vue&type=template&id=4e9566c7&"
import script from "./PaymentsSuccessPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports